import { createContext, useContext, useState, useCallback, useEffect } from "react";

const Ctx = createContext(null);
const KEY = "mpf_cart";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(read);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* noop */ }
  }, [items]);

  const addItem = useCallback((entry) => {
    if (!entry || !entry.slug || !entry.product_id) return;
    setItems((c) => {
      const ex = c.find((x) => x.slug === entry.slug && x.product_id === entry.product_id);
      if (ex) return c.map((x) => (x.slug === entry.slug && x.product_id === entry.product_id ? { ...x, quantity: x.quantity + 1 } : x));
      return [...c, {
        slug: entry.slug, farm_name: entry.farm_name || "", product_id: entry.product_id,
        name: entry.name || "", price: Number(entry.price) || 0, unit: entry.unit || "",
        tiers: entry.tiers || [], image: entry.image || "", quantity: 1,
      }];
    });
  }, []);

  const decItem = useCallback((slug, productId) => {
    setItems((c) => c.map((x) => (x.slug === slug && x.product_id === productId ? { ...x, quantity: x.quantity - 1 } : x)).filter((x) => x.quantity > 0));
  }, []);

  const removeItem = useCallback((slug, productId) => {
    setItems((c) => c.filter((x) => !(x.slug === slug && x.product_id === productId)));
  }, []);

  const clearFarm = useCallback((slug) => {
    setItems((c) => c.filter((x) => x.slug !== slug));
  }, []);

  const clearAll = useCallback(() => setItems([]), []);

  const forFarm = useCallback((slug) => items.filter((x) => x.slug === slug), [items]);
  const farmSlugs = useCallback(() => [...new Set(items.map((x) => x.slug))], [items]);

  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <Ctx.Provider value={{ items, addItem, decItem, removeItem, clearFarm, clearAll, forFarm, farmSlugs, count }}>
      {children}
    </Ctx.Provider>
  );
}

export const useCart = () => useContext(Ctx);
